export default __webpack_public_path__ + "static/publish-to-catalog-ad82c7ecd418bd328187784f3605ad95.gif";